import {Field} from "../../../../ui/Field";
import React from "react";

export const CustomerBank = ({errors,bank, OnValueChange}) => (<>

    <Field
        name="bankName"
        error={errors['bankName']}
        className="mb-3"
        defaultValue={bank.bankName}
        onChange={(e) => OnValueChange(e.target)}
    >
        Bank name
    </Field>
    <Field
        name="bankDetail"
        error={errors['bankDetail']}
        className="mb-3"
        defaultValue={bank.bankDetail}
        onChange={(e) => OnValueChange(e.target)}
    >
        Bank details
    </Field>

    <Field
        name="benefName"
        error={errors['benefName']}
        className="mb-3"
        defaultValue={bank.benefName}
        onChange={(e) => OnValueChange(e.target)}
    >
        Beneficiary name
    </Field>

    <Field
        name="account"
        error={errors['account']}
        className="mb-3"
        defaultValue={bank.account}
        onChange={(e) => OnValueChange(e.target)}
    >
        Account Number
    </Field>

    <Field
        name="swift"
        error={errors['swift']}
        className="mb-3"
        defaultValue={bank.swift}
        onChange={(e) => OnValueChange(e.target)}
    >
        Ifsc/swift code
    </Field>
</>)
